<script>
import PageLayout from '../Components/UI/PageLayout.vue'
import MainContainer from '../Components/UI/Content/MainContainer.vue'
import MainContent from '../Components/UI/Content/MainContent.vue'
import TableSubMenu from '../Components/UI/Table/TableSubMenu.vue'
import mixinComponent from '../Mixins/mixinComponent'
import { globalVariablesMixin } from '../Mixins/global'
import jsonRequestMixins from '../Mixins/jsonRequestMixins'

export default {
  components: { TableSubMenu, MainContent, MainContainer, PageLayout },

  mixins: [mixinComponent, globalVariablesMixin, jsonRequestMixins],

  data() {
    return {
      report: null,
      models: null,
      status: 0,
    }
  },
  computed: {
    submenuLabels() {
      return [
        { id: 0, name: this.$t('kpi.list.commercial') },
        { id: 1, name: this.$t('kpi.list.financial') },
        { id: 2, name: this.$t('kpi.list.operational') },
      ]
    },
  },
  methods: {
    async setActive(value) {
      this.status = value
      if (this.report == null) {
        return
      }
      const pages = await this.report.getPages()
      await pages[value].setActive()
      await this.getKpiPage(value)
    },
    async getKpiPage(value = 0) {
      if (this.report == null) {
        return
      }
      const pages = await this.report.getPages()
      await pages[value].setActive()

      try {
        const basicFilter = {
          $schema: 'http://powerbi.com/product/schema#basic',
          target: {
            table: this.conf.localDateTable,
            column: 'Année',
          },
          operator: 'In',
          values: [new Date().getFullYear()],
          filterType: this.models.FilterType.BasicFilter,
        }
        // Retrieve the active page.
        let pageWithSlicer = pages.filter(function (page) {
          return page.isActive
        })[0]

        const visuals = await pageWithSlicer.getVisuals()
        // Retrieve all visuals with the type "slicer".
        let slicers = visuals.filter(function (visual) {
          return visual.type === 'slicer'
        })

        slicers.forEach(async (slicer) => {
          // Get the slicer state.
          const state = await slicer.getSlicerState()
          if (state.targets[0].table == this.conf.localDateTable) {
            await slicer.setSlicerState({
              filters: [basicFilter],
            })
          }
        })
      } catch (errors) {}
    },
    reportFullscreen() {
      this.report.fullscreen()
    },
    async reportPrint() {
      await this.report.print()
    },
  },
  mounted() {
    if (!(user.isBusinessMan && roles.includes('ROLE_KPI_SHOW'))) {
      window.location = '/'
    }

    this.models = window['powerbi-client'].models
    let reportContainer = $('#report-container').get(0)
    powerbi.bootstrap(reportContainer, { type: 'report' })
    this.getJSON('kpi').then((json) => {
      let permissions = this.models.Permissions.All
      let reportLoadConfig = {
        type: 'report',
        tokenType: this.models.TokenType.Embed,
        accessToken: json.accessToken,
        embedUrl: json.embedUrl,
        datasetBinding: {
          datasetId: json.dataset,
        },
        permissions: permissions,
        settings: {
          panes: {
            bookmarks: {
              visible: false,
            },
            fields: {
              expanded: false,
            },
            filters: {
              expanded: false,
              visible: false,
            },
            pageNavigation: {
              visible: false,
            },
            selection: {
              visible: true,
            },
            syncSlicers: {
              visible: true,
            },
            visualizations: {
              expanded: false,
            },
          },
        },
      }

      this.report = powerbi.embed(reportContainer, reportLoadConfig)
      this.report.off('loaded')

      this.report.on('loaded', async () => {
        let pages = await this.report.getPages()
        if (pages.length > 0) {
          await pages[0].setActive()
          await this.getKpiPage()
        }
      })

      this.report.off('rendered')

      this.report.on('rendered', () => {})

      this.report.off('error')

      this.report.on('error', (event) => {})
    })
  },
}
</script>
<template>
  <PageLayout menu="kpi-index">
    <MainContainer>
      <MainContent>
        <TableSubMenu
          v-model:status="status"
          :centered="false"
          :submenu-labels="submenuLabels"
          @update:status="setActive"
        >
          <button class="btn btn-primary" @click="reportFullscreen"><i class="fas fa-expand"></i></button>
          <button class="btn btn-primary" @click="reportPrint"><i class="fas fa-print"></i></button>
        </TableSubMenu>
        <section
          id="report-container"
          class="embed-container col-lg-offset-4 col-lg-7 col-md-offset-5 col-md-7 col-sm-offset-5 col-sm-7 mx-auto mt-3"
          style="max-width: 90%"
        ></section>
        <!-- Used to display report embed error messages -->
        <section class="error-container m-5"></section>
      </MainContent>
    </MainContainer>
  </PageLayout>
</template>
